export type ReadonlyDbSetEndpoints = {
    readonly GetAll: string;
    readonly Save: string;
    readonly Update: string;
    readonly Delete: string;
};

const controller = 'api/DbSet';

const DbSetEndpoints: ReadonlyDbSetEndpoints = {
    GetAll: `${controller}/GetAll`,
    Save: `${controller}/Save`,
    Update: `${controller}/Update`,
    Delete: `${controller}/Delete`,
};

export { DbSetEndpoints };
